import React from 'react';
import PropTypes from 'prop-types';
import { MedianPriceCard as MedianPrice, LocalityLinkCard } from '@domain-group/fe-co-allhomes-shared-components';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { LocalityType } from '@domain-group/fe-allhomes-library';
import * as styles from './median-price-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ctaText = 'View district profile';
var MedianPriceCard = props => {
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  return ___EmotionJSX("a", {
    "aria-label": "View ".concat(props.districtName, " profile"),
    css: styles.medianPriceCard,
    href: getAbsoluteUrl(props.link),
    onClick: () => sendEvent('click-research-cta', {
      ctaText,
      districtName: props.districtName
    })
  }, ___EmotionJSX(LocalityLinkCard, {
    title: props.districtName,
    text: ctaText,
    localityType: LocalityType.DISTRICT.type,
    hasBorder: false,
    asDiv: true,
    css: styles.localityLinkCard,
    arrowPosition: "even"
  }), ___EmotionJSX(MedianPrice, {
    statistics: props.statistics
  }));
};
MedianPriceCard.propTypes = {
  statistics: PropTypes.shape({
    houseMedianPrice: PropTypes.number,
    housePriceYearlyDelta: PropTypes.number,
    unitMedianPrice: PropTypes.number,
    unitPriceYearlyDelta: PropTypes.number
  }),
  districtName: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired
};
MedianPriceCard.defaultProps = {
  statistics: {}
};
export default MedianPriceCard;